import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { SharedModule } from '../../_shared/shared.module';
import { ChartsModule } from 'ng2-charts';
import { CommonModule } from '@angular/common';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { BrandOverview } from './brand-overview/brand-overview.component';
import { DataSource } from './data-source/data-source.component';
import { SentimentOverview } from './sentiment-overview/sentiment-overview.component';
import { TopContentDiscuss } from './top-content-discuss/top-content-discuss.component';
import { DiscussionDevelopment } from './discussion-development/discussion-development.component';
import { DetailContent } from './detail-content/detail-content.component';
import { AppFeaturedContent } from './featured-content/app-featured-content.component';
import { SafeHtmlPipe } from './pipe/safeHtml.pipe';
import { BrandComparison } from './brand-comparison/brand-comparison.component';
import { ReportComponentService } from './reports-component.service';
import { OutStandingStatistics } from './outstanding-statistics/outstanding-statistics.component';
import { TableContent } from './table-content/table-content.component';
import { HealthBrandComponent } from './health-brand/health-brand.component';
import { SentimentBrandReport } from './sentiment-brand-report/sentiment-brand-report.component';
import { DiscussionDevelopmentBrands } from './discussion-development-brands/discussion-development-brands.component';
import { ChannelDiscussion } from './discussion-channel/discussion-channel.component';
import { PageAnalytic } from './page-analytic/page-analytic.component';
import { DiscussionMarketSharePreview } from './discussion-market-share-preview/discussion-market-share-preview.component';
import { UserOverView } from './user-overview/user-overview.component';
import { CompareSource } from './compare-source/compare-source.component';
import { ComparePageAnalytic } from './compare-pages-analysis/compare-pages-analysis.component';
import { DiscussionTotalReportChartComponent } from './discussion-total-report-chart/discussion-total-report-chart.component';
import { DiscussionTvSocialChartComponent } from './discussion-tv-social-chart/discussion-tv-social-chart.component';
import { NumberVNPipe } from './pipe/number-vn.pipe';
import { DiscussionTrend } from './discussion-trend/discussion-trend.component';
import { SentimentIndex } from './sentiment-index/sentiment-index.component';
import { CKEditorModule } from 'ng2-ckeditor';


@NgModule({
    imports: [
        ChartsModule,
        TabsModule,
        BsDatepickerModule.forRoot(),
        CommonModule,
        HttpClientModule,
        AngularMultiSelectModule,
        FormsModule,
        SharedModule,
        ReactiveFormsModule,
        DataTablesModule,
        CKEditorModule
    ],
    declarations: [
        SafeHtmlPipe,
        BrandOverview,
        DataSource,
        SentimentOverview,
        TopContentDiscuss,
        DiscussionDevelopment,
        DetailContent,
        AppFeaturedContent,
        BrandComparison,
        OutStandingStatistics,
        DiscussionDevelopmentBrands,
        HealthBrandComponent,
        SentimentBrandReport,
        TableContent,
        ChannelDiscussion,
        PageAnalytic,
        DiscussionMarketSharePreview,
        UserOverView,
        CompareSource,
        ComparePageAnalytic,
        DiscussionTotalReportChartComponent,
        DiscussionTvSocialChartComponent,
        DiscussionTrend,
        SentimentIndex,
        NumberVNPipe
    ],
    exports: [
        BrandOverview,
        DataSource,
        SentimentOverview,
        TopContentDiscuss,
        DiscussionDevelopment,
        DetailContent,
        AppFeaturedContent,
        BrandComparison,
        OutStandingStatistics,
        DiscussionDevelopmentBrands,
        HealthBrandComponent,
        SentimentBrandReport,
        TableContent,
        ChannelDiscussion,
        PageAnalytic,
        DiscussionMarketSharePreview,
        UserOverView,
        CompareSource,
        ComparePageAnalytic,
        DiscussionTotalReportChartComponent,
        DiscussionTvSocialChartComponent,
        DiscussionTrend,
        SentimentIndex
    ],
    providers: [ReportComponentService]
})
export class ReportsComponentModule { }




// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/reports-component.module.ts